angular.module('lead')
    .directive('leadStatusSelect', function (LeadStatusService) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: false,
            scope: {
                filterField: "=?",
                required: "=",
                modelType: "=",
                onChange: "&",
                notWait: "="
            },
            templateUrl: "app/lead/status/select.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {
                scope.filterField = scope.filterField || false;
                scope.executeOnChange = scope.onChange || angular.noop;
                scope.initialValue = angular.copy(ngModelCtrl.$modelValue)
                loadItems();

                function loadItems(){
                    let items = LeadStatusService.statuses;
                    if(scope.notWait === true)
                        items = items.filter(item => item !== "WAIT");
                    scope.items = items;
                }

                ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue;
                ngModelCtrl.$formatters.push(modelValue => modelValue);
                ngModelCtrl.$parsers.push(viewValue => {
                    return scope.modelType === "id" ? viewValue.id : viewValue;
                });

                scope.onSelectionChanged = ($item, $model) => {
                    ngModelCtrl.$setViewValue($item);
                    ngModelCtrl.$validate();
                    ngModelCtrl.$render();
                    if (angular.isFunction(scope.executeOnChange())) {
                        scope.executeOnChange()($item);
                    }
                }
            }
        };
    })
